import { Box, Typography, styled } from '@mui/material';
import { useGetApprovedAmount, useApply } from '../services/flowManager';
import { MuiTrackerButton } from './TrackerButtonWrapper';
import { ButtonName } from '../constants';
import { useUpdateConfigurationHandler } from '../services/lendersConfigurationManager';
import { useState } from 'react';

const StyledButtonWrapper = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1),
  justifyContent: 'space-around',
}));

const ApplyButton = () => {
  const [loading, setLoading] = useState(false);
  const stopLoading = () => setLoading(false);
  const approvedAmount = useGetApprovedAmount();
  const apply = useApply(stopLoading);
  const updateConfigurationHandler = useUpdateConfigurationHandler();

  return (
    <>
      {!approvedAmount && (
        <MuiTrackerButton
          loaderColor="white"
          loading={loading}
          buttonName={ButtonName.StartApply}
          color="primary"
          fullWidth
          data-testid="apply-btn"
          onClick={async () => {
            setLoading(true);
            updateConfigurationHandler();
            await apply();
          }}
        >
          <StyledButtonWrapper>
            <Typography variant="inherit">Start on this Device</Typography>
          </StyledButtonWrapper>
        </MuiTrackerButton>
      )}
    </>
  );
};

export default ApplyButton;
